import { DialogComponent } from '@theme/dialog';
import { StandardEvents } from '@shopify/events';

/**
 * A custom element that manages the "Shop the Look" drawer opened from a
 * collection grid tile. Closes itself on a successful add to cart so the
 * cart drawer can take over, mirroring QuickAddDialog.
 */
class ShopTheLookComponent extends DialogComponent {
  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    this.addEventListener(StandardEvents.cartLinesUpdate, this.#handleCartUpdate, {
      signal: this.#abortController.signal,
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#abortController.abort();
  }

  /**
   * Closes the drawer on successful cart update
   * @param {import('@shopify/events').CartLinesUpdateEvent} event - The cart lines update event
   */
  #handleCartUpdate = (event) => {
    event.promise
      ?.then(({ detail }) => {
        if (detail?.didError) return;
        this.closeDialog();
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[shop-the-look] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('shop-the-look-component')) {
  customElements.define('shop-the-look-component', ShopTheLookComponent);
}
